import React from "react";
// import PropTypes from "prop-types";
import { Row } from "jsxstyle";
import Table from "components/Table";
import Button from "components/Button";
import Separator from "components/Separator";
import CurrencyFormat from "components/CurrencyFormat";
import DeleteCMBSBPieceBuyer from "../bPieceBuyers/DeleteCMBSBPieceBuyer";
import PermissionValidator from "components/PermissionValidator";
import { ADMIN_ROLE, DATA_TEAM_ROLE } from "consts";
import PercentFormat from "components/PercentFormat";

function CMBSBPieceBuyersTable({
  data,
  dealSize,
  pending,
  onReload,
  onRequestEdit,
}) {
  return (
    <PermissionValidator
      allowedFor={[ADMIN_ROLE, DATA_TEAM_ROLE]}
      shouldHide={false}
    >
      {({ isAllowed }) => (
        <Table
          pending={pending}
          data={data}
          columns={[
            {
              title: "Buyer",
              dataIndex: "buyer_entity_id.long_name",
              key: "buyer_entity_id.long_name",
            },
            {
              title: "Amount",
              dataIndex: "b_piece_amount",
              key: "b_piece_amount",
              render: (b_piece_amount) => (
                <CurrencyFormat amount={b_piece_amount} />
              ),
            },
            {
              title: "Amount(%)",
              dataIndex: "b_piece_amount",
              key: "b_piece_amount",
              render: (b_piece_amount) => (
                <PercentFormat
                  amount={(((b_piece_amount || 0) / dealSize) * 100).toFixed(4)}
                />
              ),
            },
            ...(isAllowed
              ? [
                  {
                    title: "Actions",
                    dataIndex: "",
                    key: "",
                    width: 100,
                    render: (item) => (
                      <Row>
                        <Button
                          icon="edit"
                          onClick={() => onRequestEdit(item)}
                        />
                        <Separator />
                        <DeleteCMBSBPieceBuyer
                          buyer={item}
                          onDelete={onReload}
                        />
                      </Row>
                    ),
                  },
                ]
              : []),
          ]}
        />
      )}
    </PermissionValidator>
  );
}

CMBSBPieceBuyersTable.propTypes = {};

CMBSBPieceBuyersTable.defaultProps = {};

export default CMBSBPieceBuyersTable;
